// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-wrapper {
  max-width: 500px;
  text-align: center;
  margin: 0 auto;
  padding-bottom: 50px;
  padding-top: 160px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/page-not-found/page-not-found.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;AACJ","sourcesContent":[".center-wrapper {\n    max-width: 500px;\n    text-align: center;\n    margin: 0 auto;\n    padding-bottom: 50px;\n    padding-top: 160px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
